(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-block/deposit-restrictions-first-dialog.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-block/deposit-restrictions-first-dialog.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Icon = svs.ui.ReactIcon;
const Button = svs.ui.ReactButton;
const RadioGroup = svs.ui.reactForm.RadioGroup;
const RadioButton = svs.ui.reactForm.RadioButton;
const putDepositAmount = svs.accountservicesReact.deposit.services.depositService.putDepositAmount;
const _svs$accountservicesR = svs.accountservicesReact.deposit.dialogs.blockInfoDialogs,
  showSetDepositTimesDialog = _svs$accountservicesR.showSetDepositTimesDialog,
  showSetDepositTimesSucessDialog = _svs$accountservicesR.showSetDepositTimesSucessDialog,
  generalErrorDialog = _svs$accountservicesR.generalErrorDialog;
const DepositRestrictionsFirstDialog = _ref => {
  var _blockInfo$depositRes;
  let blockInfo = _ref.blockInfo,
    setIsCheckBlock = _ref.setIsCheckBlock;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showMore = _React$useState2[0],
    isShowMore = _React$useState2[1];
  const _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    depositTimesChoice = _React$useState4[0],
    setDepositTimesChoice = _React$useState4[1];
  const convertDepositAmount = {
    1: 'en',
    2: 'två',
    3: 'tre',
    4: 'fyra',
    5: 'fem'
  };
  const setDepositAmount = async depositTimesChoice => {
    const putDepositAmountResponse = await putDepositAmount(depositTimesChoice);
    if (putDepositAmountResponse !== null && putDepositAmountResponse !== void 0 && putDepositAmountResponse.error) {
      generalErrorDialog();
    } else {
      switch (depositTimesChoice) {
        case 0:
          showSetDepositTimesSucessDialog('Du kommer inte att kunna göra fler insättningar idag');
          break;
        case 1:
          showSetDepositTimesSucessDialog('Du kommer inte att kunna göra fler insättningar idag');
          break;
        default:
          showSetDepositTimesSucessDialog("Du kommer att kunna g\xF6ra ".concat(convertDepositAmount[depositTimesChoice], " ins\xE4ttningar till idag"));
          break;
      }
      setIsCheckBlock(true);
    }
  };
  const submitDepositTimes = async () => {
    switch (depositTimesChoice) {
      case 0:
        if (await showSetDepositTimesDialog('Vill du begränsa dina insättningar helt idag?')) {
          setDepositAmount(depositTimesChoice);
        }
        break;
      case depositTimesChoice:
        if (await showSetDepositTimesDialog("Vill du begr\xE4nsa dina ins\xE4ttningar till ".concat(convertDepositAmount[depositTimesChoice], " idag?"))) {
          setDepositAmount(depositTimesChoice);
        }
        break;
      default:
        generalErrorDialog();
        break;
    }
  };
  return React.createElement("div", {
    className: "f-body line-height-150"
  }, React.createElement("div", {
    className: "padding-v-2 align-center"
  }, React.createElement(Icon, {
    icon: "help",
    size: "700"
  })), React.createElement("div", {
    className: "f-center"
  }, React.createElement("h2", {
    className: "h2 margin-v-1 line-height-120-override"
  }, "Hur m\xE5nga fler ins\xE4ttningar vill du kunna g\xF6ra idag?"), React.createElement("p", {
    className: "margin-0 padding-bottom-2"
  }, "Du har gjort", ' ', (blockInfo === null || blockInfo === void 0 || (_blockInfo$depositRes = blockInfo.depositRestrictions) === null || _blockInfo$depositRes === void 0 ? void 0 : _blockInfo$depositRes.depositsMade) === 2 ? 'två' : 'tre', ' ', "ins\xE4ttningar idag. Genomsnittet \xE4r en g\xE5ng per dag.")), showMore && React.createElement(RadioGroup, {
    multipleLines: true,
    size: 200
  }, React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(0),
    value: "0"
  }, "INGA FLER"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(1),
    value: "1"
  }, "1"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(2),
    value: "2"
  }, "2"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(3),
    value: "3"
  }, "3"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(4),
    value: "4"
  }, "4"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(5),
    value: "5"
  }, "5")), !showMore && React.createElement(React.Fragment, null, React.createElement(RadioGroup, {
    multipleLines: true,
    size: 200
  }, React.createElement(RadioButton, {
    minWidth: "50%",
    name: "deposit-question-basic",
    onChange: () => setDepositTimesChoice(0),
    value: "0"
  }, "INGA FLER"), React.createElement(RadioButton, {
    minWidth: "50%",
    name: "deposit-question-basic",
    onChange: () => setDepositTimesChoice(1),
    value: "1"
  }, "1")), React.createElement("div", {
    className: "padding-top-1"
  }, React.createElement(Button, {
    block: true,
    onClick: isShowMore,
    transparent: true
  }, "Visa fler alternativ"))), React.createElement("div", {
    className: "padding-top-1"
  }, React.createElement(Button, {
    block: true,
    disabled: depositTimesChoice === null,
    inverted: true,
    onClick: submitDepositTimes
  }, "Okej")));
};
svs.accountservicesReact.deposit.depositBlock.DepositRestrictionsFirstDialog = DepositRestrictionsFirstDialog;

 })(window);